<template>
  <div class="flex flex-col divide-y divide-gray-200">
    <!-- download the app section -->
    <div class="flex flex-col gap-2 p-6">
      <p class="font-bold">{{ $t('GetZainApp') }}</p>
      <div class="flex flex-row gap-4">
        <a href="https://apps.apple.com/kw/app/zain-kw/id399198545"
          ><img src="../../assets/apple.svg" alt="Apple Store"
        /></a>
        <a
          href="https://play.google.com/store/apps/details?id=com.zainkw.zain&hl=ar&gl=US"
          ><img src="../../assets/google.svg" alt="Google Store"
        /></a>
      </div>
    </div>
    <!--    copy rights section-->
    <div class="flex flex-col text-center pt-6 gap-3">
      <p class="text-eezeeGray">{{ $t('Copyright') }}</p>
      <div class="flex flex-row justify-center gap-2 text-xs font-semibold">
        <a
          class="hover:text-primary"
          href="https://www.kw.zain.com/shop/terms-conditions"
          >{{ $t('Terms&Conditions') }}</a
        >
        <p>-</p>
        <a
          class="hover:text-primary"
          href="https://www.kw.zain.com/shop/privacy-policy"
          >{{ $t('PrivacyPolicy') }}</a
        >
        <p>-</p>
        <a
          class="hover:text-primary"
          href="https://citra.gov.kw/sites/en/pages/reports.aspx"
          >{{ $t('Citra') }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EezeeFooter'
}
</script>

<style scoped></style>
